import { render, staticRenderFns } from "./FundingProjectsGrid.vue?vue&type=template&id=b7e0a448&scoped=true&"
import script from "./FundingProjectsGrid.vue?vue&type=script&lang=ts&"
export * from "./FundingProjectsGrid.vue?vue&type=script&lang=ts&"
import style0 from "./FundingProjectsGrid.vue?vue&type=style&index=0&id=b7e0a448&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e0a448",
  null
  
)

export default component.exports